





















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import appStorage from "@/lib/appStorage";
import { getLocale } from "@/lib/localeHelper";
import config from "@/config";
import { BaseMenuItem } from "@/types";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import { getAvailableLocales } from "./config";

export default defineComponent({
  name: "LocaleSwitch",
  components: { BaseMenu, BaseIconButton },
  props: {
    menuPosition: { type: String as PropType<"left" | "right" | "center" | "bottom-center"> },
  },
  setup(_, { root }) {
    const currentLocale = ref(getLocale());

    const menuItems = computed(() => getAvailableLocales().filter(i => config.availableLocales?.includes(i.name)));

    const activeItem = computed(() => menuItems.value.find(item => item.name === currentLocale.value));

    const handleLocaleChange = (value: BaseMenuItem["name"]) => {
      if (value !== currentLocale.value) {
        currentLocale.value = value;
        root.$i18n.locale = value;
        appStorage.setString("locale", value);
      }
    };

    return { menuItems, handleLocaleChange, activeItem, currentLocale };
  },
});
